<template>
<div>
    <canvas style="display: block;max-width: 100%;max-height: 100%;width: auto;height: auto;" :id="String(id)"></canvas>
</div>
</template>

<script>
export default {
  name: 'Image',
  props: ['src', 'id'],
  data () {
    return {
        base64: '',
    }
  },
  mounted(){
    var myCanvas = document.getElementById(String(this.id));
    var ctx = myCanvas.getContext('2d');
    var img = new Image;
    img.onload = function(){
        myCanvas.width = img.width;
        myCanvas.height = img.width*9/16;
        ctx.drawImage(img,0,0);
    };
    img.src = this.src;
  },
  created() {

  },
  methods: {
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ImageAvata.vue